<script>
import moment from 'moment';
import draggable from 'vuedraggable';
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import ProductService from '@/services/product';

moment.locale('pt-BR');

export default {
  page: {
    title: "Produtos",
  },
  components: { Layout, PageHeader, draggable },
  data() {
    return {
      title: "Produtos",
      loading: false,
      products: [],
      productSelected: {},
      
      searchValue: '',
      searchStatus: 'all',
      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,

      showModal: false,
      searchEmptyField: false,

      indexToRemove: null,
      indexToRemoveOriginal: null,
      imageToRemove: null,
      imageArrayToRemove: 'images',

      fields: [
        { key: 'image', sortable: false, label: 'Foto' },
        { key: 'barcode', sortable: false, label: 'Código' },
        { key: 'description', sortable: false, label: 'Descrição' },
        { key: 'price', sortable: false, label: 'Preço' },
        { key: 'stock', sortable: false, label: 'Estoque' },
        { key: 'status', sortable: false, label: 'Status' },
        { key: 'actions', label: 'Ações', class: 'nowrap-col' }
      ],
    }
  },
  computed: {
    rows() {
      return this.products.length;
    }
  },
  methods: {
    loadProducts(showLoading = true, page = 1) {
      let loader;

      if (showLoading) {
        loader = this.$loading.show();
      }

      ProductService.getAll(page, this.searchValue, this.searchStatus)
        .then(res => {
          this.products = res.data.products;
          this.count = res.data.count;
          this.currentCount = res.data.currentCount;
          this.currentPage = res.data.currentPage;
          this.totalPages = res.data.totalPages;
          this.perPage = res.data.perPage;
          this.startIndex = res.data.startIndex;
          this.endIndex = res.data.endIndex;

          if (showLoading) {
            loader.hide();
          }
        })
      .catch(() => {
        if (showLoading) {
          loader.hide();
        }
      })
    },
    
    onPageChange() {
      window.scrollTo(0,0);
      this.loadProducts(true, this.currentPage);
    },

    search() {
      this.searchEmptyField = false,
      this.loadProducts(true, 1);
    },

    deactivateProduct() {
      this.$bvModal.hide('modal-inactive');

      let loader = this.$loading.show();

      ProductService.deactivateProduct(this.productSelected._id).then(() => {
        this.loadProducts(false, this.currentPage);

        loader.hide();
        this.$toast.open('Produto inativado com sucesso')
      }).catch((err) => {
        loader.hide();
        
        if (err && err.response.data.code && err.response.data.code === 'E9999') {
          return this.$toast.warning(err.response.data.msg);
        }

        this.$toast.error('Ocorreu um erro inesperado');
      })
    },

    activateProduct() {
      this.$bvModal.hide('modal-active');

      let loader = this.$loading.show();

      ProductService.activateProduct(this.productSelected._id).then(() => {
        this.loadProducts(false, this.currentPage, this.searchValue);

        loader.hide();
        this.$toast.open('Produto ativado com sucesso')
      }).catch((err) => {
        loader.hide();

        if (err && err.response.data.code && err.response.data.code === 'E9999') {
          return this.$toast.warning(err.response.data.msg);
        }

        this.$toast.error('Ocorreu um erro inesperado');
      })
    },

    removeImage() {
      this.$bvModal.hide('modal-remove-image');

      let loader = this.$loading.show();

      ProductService.removeImage(this.productSelected._id, this.imageToRemove, this.imageArrayToRemove).then(() => {
        loader.hide();
        this.$bvModal.hide('modal-images');
        this.loadProducts(false, this.currentPage);
        this.$toast.open('Imagem removida com sucesso');
      }).catch(() => {
        loader.hide();
        this.$toast.error('Ocorreu um erro ao remover a imagem');
      })
    },

    imageFileName(url) {
      if (!url) return '';
      const clean = url.split('?')[0];
      return clean.substring(clean.lastIndexOf('/') + 1);
    },

    persistImagesOrder(type) {
      const payload = type === 'originalImages'
        ? { originalImages: this.productSelected.originalImages }
        : { images: this.productSelected.images };

      ProductService.updateImages(this.productSelected.code, payload)
        .then(() => {
          this.$toast.open('Ordem das fotos atualizada');
        })
        .catch(() => {
          this.$toast.error('Erro ao salvar a nova ordem');
          this.loadProducts(false, this.currentPage);
        });
    },
  },
  mounted() {
    this.loadProducts();
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="search" class="mb-2">
              <div class="row">
                <div class="col-lg-5 col-sm-6">
                  <div class="form-group">
                    <label>Descrição ou Código do Produto</label>
                    <input
                      type="text"
                      v-model="searchValue"
                      class="form-control"
                    />
                  </div>
                </div>

                <div class="col-lg-5 col-sm-6 d-flex align-items-center">
                  <div class="form-group">
                    <label>Status</label>
                    <select class="form-control" v-model="searchStatus">
                      <option value="all">TODOS</option>
                      <option value="active">ATIVOS</option>
                      <option value="inactive">INATIVOS</option>
                      <option value="noInfo">SEM PREÇO/ESTOQUE/FOTO</option>
                    </select>
                  </div>

                  <b-button type="submit" class="btn-rounded ml-3 mt-2" variant="primary">Pesquisar</b-button>
                  <!-- <b-button class="btn-rounded ml-2" variant="outline-primary" @click="exportData">Exportar</b-button> -->
                </div>

                <!-- <div class="col-lg-3 col-sm-6">
                  <div class="form-group">
                    <label>Tipo de Usuário</label>
                    <select class="form-control" v-model="searchCustomerType">
                      <option value="all">TODOS</option>
                      <option value="agent">REPRESENTANTE</option>
                      <option value="customer">CLIENTE</option>
                    </select>
                  </div>
                </div> -->
              </div>


              <!-- <div class="button-search">
                <b-button type="submit" variant="primary" v-if="!loading">Pesquisar</b-button>
                <b-button class="ml-2" variant="outline-primary" @click="exportData" v-if="!loading">Exportar</b-button>
                <a href="javascript:void(0);" class="text-primary" v-if="loading">
                  <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
                </a>
              </div> -->
            </form>


            <div v-if="products && products.length > 0">
              <b-table
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="products"
                :fields="fields"
                responsive="sm"
                head-variant="light"
              >
                <template v-slot:cell(actions)="row">
                  <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
                    <template v-slot:button-content>
                      <i class="mdi mdi-dots-horizontal font-size-18"></i>
                    </template>

                    <b-dropdown-item v-b-modal.modal-active :disabled="row.item.status === 'active' || row.item.status === 'noInfo'" @click="productSelected = row.item">
                      <i class="far fa-thumbs-up text-success mr-2 mt-2"></i> Ativar Produto
                    </b-dropdown-item>

                    <b-dropdown-item v-b-modal.modal-inactive :disabled="row.item.status === 'inactive' || row.item.status === 'noInfo'" @click="productSelected = row.item">
                      <i class="fas fa-ban text-danger mr-2 mt-2"></i> Inativar Produto
                    </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>

                    <b-dropdown-item v-b-modal.modal-images :disabled="!row.item.image" @click="productSelected = row.item">
                      <i class="fas fa-images text-warning mr-2 mt-2"></i> Gerenciar Fotos
                    </b-dropdown-item>
                  </b-dropdown>
                </template>

                <template v-slot:cell(image)="row">
                  <img
                    v-if="row.item.image"
                    :src="row.item.image"
                    alt="product-img"
                    title="product-img"
                    class="avatar-sm"
                  />

                  <p v-if="!row.item.image"></p>
                </template>

                <template v-slot:cell(description)="row">
                  <p class="mb-0">{{row.item.description}}</p>
                  <p class="text-muted font-size-11 mt-0">{{row.item.dimensions}}</p>
                </template>

                <template v-slot:cell(price)="row">
                  <p v-if="row.item.price" class="mb-0">R$ {{row.item.price | currency}}</p>
                  <p v-if="!row.item.price">-</p>
                </template>

                <template v-slot:cell(status)="row">
                  <span
                    class="badge badge-pill badge-soft-success font-size-12"
                    :class=" {
                      'badge-soft-danger': row.item.status === 'noInfo',
                      'badge-soft-dark': row.item.status === 'inactive',
                    }"
                  >{{row.item.statusDescription}}</span>
                </template>
              </b-table>

              <div class="row justify-content-md-between align-items-md-center mt-4">
                <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>
                <!-- end col-->
                <div class="col-xl-5">
                  <div class="text-md-right float-xl-right mt-2 pagination-rounded">
                    <b-pagination
                      v-model="currentPage" 
                      :total-rows="count"
                      :per-page="perPage"
                      @input="onPageChange"
                    ></b-pagination>
                  </div>
                </div>
                <!-- end col-->
              </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <b-modal
      id="modal-inactive"
      title="Confirmação"
      title-class="font-18"
      centered
    >
      <p>Confirma a inativação do produto {{ productSelected.barcode}} - {{productSelected.description}}?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-inactive')" class="mr-3">Fechar</b-btn>
        <b-btn variant="primary" @click="deactivateProduct">Inativar</b-btn>
      </div>
    </b-modal>

    <b-modal
      id="modal-active"
      title="Confirmação"
      title-class="font-18"
      centered
    >
      <p>Confirma a ativação do produto {{ productSelected.barcode}} - {{productSelected.description}}?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-active')" class="mr-3">Fechar</b-btn>
        <b-btn variant="primary" @click="activateProduct">Ativar</b-btn>
      </div>
    </b-modal>

    <b-modal
      id="modal-images"
      title="Gerenciar Fotos"
      title-class="font-18"
      centered
      size="lg"
    >
      <label>Fotos do Site</label>
      <small class="text-muted d-block mb-2">Arraste para reordenar</small>

      <draggable
        v-if="productSelected.images"
        v-model="productSelected.images"
        class="images"
        :animation="200"
        ghost-class="image-ghost"
        @end="persistImagesOrder('images')"
      >
        <div v-for="(image, index) in productSelected.images" :key="image" class="image" @mouseover="indexToRemove = index" @mouseleave="indexToRemove = null">
          <div v-if="image !== 'temp' ? true : false" class="image-group">
            <img :src="image" />

            <a v-if="indexToRemove === index" href="javascript:void(0);" class="action-icon remove-image" v-b-modal.modal-remove-image @click.stop="imageToRemove = image; imageArrayToRemove = 'images'" >
              <i class="mdi mdi-trash-can font-size-14"></i>
            </a>

            <span class="image-caption">{{ imageFileName(image) }}</span>
          </div>
        </div>
      </draggable>

      <div v-if="productSelected.originalImages && productSelected.originalImages.length">
        <label>Fotos em Alta</label>
        <small class="text-muted d-block mb-2">Arraste para reordenar</small>

        <draggable
          v-model="productSelected.originalImages"
          class="images"
          :animation="200"
          ghost-class="image-ghost"
          @end="persistImagesOrder('originalImages')"
        >
          <div v-for="(image, index) in productSelected.originalImages" :key="image" class="image" @mouseover="indexToRemoveOriginal = index" @mouseleave="indexToRemoveOriginal = null">
            <div v-if="image !== 'temp' ? true : false" class="image-group">
              <img :src="image" />

              <a v-if="indexToRemoveOriginal === index" href="javascript:void(0);" class="action-icon remove-image" v-b-modal.modal-remove-image @click.stop="imageToRemove = image; imageArrayToRemove = 'originalImages'" >
                <i class="mdi mdi-trash-can font-size-14"></i>
              </a>

              <span class="image-caption">{{ imageFileName(image) }}</span>
            </div>
          </div>
        </draggable>
      </div>

      <div slot="modal-footer">
        <b-btn variant="primary" @click="$bvModal.hide('modal-images')">Fechar</b-btn>
      </div>
    </b-modal>

    <b-modal id="modal-remove-image" title="Excluir Imagem" title-class="font-18" centered>
      <p>Confirma a exclusão da imagem selecionada?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-remove-image')" class="mr-3">Cancelar</b-btn>
        <b-btn variant="primary" @click="removeImage">Excluir</b-btn>
      </div>
    </b-modal>

  </Layout>
</template>

<style lang="scss">
  .images {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;

    .image {
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: grab;

      &:active {
        cursor: grabbing;
      }

      .image-group {
        flex-direction: column;
        display: flex;
        position: relative;
        align-items: center;
      }

      .image-caption {
        font-size: 11px;
        color: #6c757d;
        text-align: center;
        word-break: break-all;
        max-width: 150px;
        margin: 0 20px 10px 20px;
      }
    }

    img {
      height: 150px;
      margin: 20px 20px 4px 20px;
      min-height: 80px;
    }
  }

  .image-ghost {
    opacity: 0.4;
    background: #e9ecef;
  }

  .remove-image {
    position: absolute;
    right: 14px;
    background-color: #fff;
    color: red;
    height: 10px;
    width: 10px;
    top: 14px;
    padding: 15px;
    margin: 0px;
    display: flex;
    border-radius: 50%;
    /* line-height: 10px; */
    justify-content: center;
    align-items: center;
  }
</style>